export interface Filter<T, M>{
  propKey?: keyof T;
  name: string;
  filter: (element: T, filterCriteria: M) => boolean | null;
}

export function filterData<T, M>(data: T[], filters: Filter<T, M>[], filterCriteria: M, strategy: 'AND'|'OR' = 'AND'): T[] {
  const result: T[] = data.filter((element) => {
    const filterResults = filters.filter((currentFilter) => {
      const filterResult = currentFilter.filter(element, filterCriteria);
      if (filterResult === null){
        return strategy === 'AND';
      }
      return filterResult;
    });
    if (strategy === 'AND'){
      return filterResults.length === filters.length;
    } else {
      return !!filterResults.length;
    }
  });

  return result;
}
